<template>
	<div>
		  <Breadcrumbs main="Raw Materials" title="Edit Raw Materials" />
			 <div class="container-fluid">
				<div class="row">
				   <div class="col-sm-12">
					  <div class="card">
						 <div class="card-body">
 
							<div class="row mb-3">
							   	<div class="col-12">
									<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
							   	</div>
							</div>
 
							<form  @submit.prevent="" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Product Name<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="product_name"/>
											</div>
										</div>

										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Product Image<span class="text-danger">*</span></label>
												<input class="form-control" type="file" placeholder=""/>
												
											</div>
										</div>
										
									</div>

									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit">Save</button>
										</div>
									</div>
	
								</div>
							</form>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
 
	</div>
 </template>

<script>
	export default {
		name: "Add Campaign Page",
		

		data() {
			return {
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},

				product_name: "Product 1",

			};
		},
		created() {
			

		},
		
		methods: {

			clearForm() {
				this.edit = false;
				this.errors = {};
			},

		},
	};

</script>